import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { Seo } from "@/components/common/Seo";
import { PAGES, PRODUCT_AREAS, IMAGES, SEO } from "@/content/site";

export default function ProductAreas() {
  const p = PAGES.productAreas;
  return (
    <div data-testid="page-product-areas">
      <Seo title={SEO.productAreas.t} description={SEO.productAreas.d} path="/product-areas" />
      <PageHero eyebrow={p.eyebrow} title={p.title} lead={p.lead} image={IMAGES.pharmaLab} />
      <section className="container-x py-16 lg:py-24">
        <div className="space-y-8">
          {PRODUCT_AREAS.map((area, idx) => (
            <Reveal key={area.id} delay={idx * 0.05}>
              <div
                className={`grid gap-8 overflow-hidden rounded-2xl border border-slate-200/80 bg-white lg:grid-cols-2 ${
                  idx % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
                }`}
              >
                <div className="relative min-h-[260px] overflow-hidden">
                  <img src={area.image} alt={area.title} className="absolute inset-0 h-full w-full object-cover" />
                </div>
                <div className="flex flex-col justify-center p-8 lg:p-12">
                  <span className="eyebrow">0{idx + 1}</span>
                  <h2 className="mt-3 text-2xl font-semibold text-ink-heading">{area.title}</h2>
                  <p className="mt-4 text-base leading-relaxed text-ink-body">{area.summary}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-14 rounded-2xl bg-azeka-sage p-8 text-center lg:p-12">
          <p className="text-lg font-medium text-azeka-navy">Looking to source or supply within these categories?</p>
          <Link
            to="/contact"
            data-testid="product-areas-cta"
            className="mt-5 inline-flex items-center gap-2 rounded-full bg-azeka-navy px-7 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-azeka-navy2 hover:-translate-y-0.5"
          >
            Make an Enquiry <ArrowRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
